var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { compose, margin, width } from 'styled-system';
import { theme } from '../../essentials/theme';
import { ChevronDownIcon } from '../../icons';
import { extractClassNameProps, extractWidthProps, extractWrapperMarginProps } from '../../utils/extractProps';
import { useGeneratedId } from '../../utils/hooks/useGeneratedId';
import { SelectInput } from './SelectInput';
import { SelectLabel } from './SelectLabel';
const SelectWrapper = styled.div.attrs({ theme }).withConfig({ displayName: "SelectWrapper", componentId: "sc-xea1uf" }) `
    display: inline-block;
    position: relative;
    box-sizing: border-box;

    ${compose(margin, width)}
`;
const IconNode = styled.div.withConfig({ displayName: "IconNode", componentId: "sc-tboj92" }) `
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    pointer-events: none;
    right: 0.5rem;
    top: 0;
`;
const Select = (_a) => {
    var { variant = 'boxed', size = 'medium' } = _a, props = __rest(_a, ["variant", "size"]);
    const { classNameProps, restProps: withoutClassName } = extractClassNameProps(props);
    const { marginProps, restProps: withoutMargin } = extractWrapperMarginProps(withoutClassName);
    const { widthProps, restProps } = extractWidthProps(withoutMargin);
    const { label, children, placeholder } = restProps, rest = __rest(restProps, ["label", "children", "placeholder"]);
    const id = useGeneratedId(props.id);
    return (React.createElement(SelectWrapper, Object.assign({}, classNameProps, marginProps, widthProps),
        React.createElement(SelectInput, Object.assign({ variant: variant, size: size }, rest, { id: id }),
            placeholder ? React.createElement("option", { value: "" }, placeholder) : undefined,
            children),
        React.createElement(IconNode, { className: "svg-icon" },
            React.createElement(ChevronDownIcon, null)),
        label && React.createElement(SelectLabel, { htmlFor: id }, label)));
};
export { Select };
